

import React from 'react';
import Lottie from 'lottie-react';
import carAnimationData from "assets/animations/bot/Car.json";

function CarMovingLeftToRight() {
  return (
    <div style={{
      width: '100%',
      height: 100,
     
      overflow: 'hidden',
      position: 'relative'
    }}>
      
  
      <div 
        className="car-container"
        style={{
          position: 'absolute',
          bottom: '-70px',
          animation: 'moveLeftToRight 15s linear infinite'
        }}
      >
        <Lottie 
          animationData={carAnimationData}
          loop={true}
          style={{ width: 180, height: 180 }}
        />
      </div>

      <style>{`
        @keyframes moveLeftToRight {
          0% {
            right: -300px; 
          }
          100% {
            right: 100%;    
          }
        }
      `}</style>
    </div>
  );
}

export default CarMovingLeftToRight;
